import {
	type Period,
	type PeriodRange,
	type PeriodTable,
	type RequestedResponder,
} from '@atlassian/eoc-schedule-common';

export enum LayerTypes {
	BaseLayer = 'defaultLayers',
	OverrideLayer = 'overrideLayers',
	ForwardingLayer = 'forwardingLayers',
	FinalLayer = 'finalLayers',
}

export type ShiftContext = {
	scheduleId: string;
};

export type DatePartition = {
	year: number;
	month: number;
	day: number;
	hour: number;
	minute: number;
};

export enum ShiftStatus {
	Default = 'default',
	Multi = 'multi',
	MultiQuickOverride = 'multi-quick-override',
	Single = 'single',
	SingleViewOnly = 'single-view-only',
	SingleOverriden = 'single-overriden',
	SingleQuickOverride = 'single-quick-override',
}

// Confirm, Customize Override, Edit, Revert are not actions! They have side effects
// In success of that side effect call action: 'Close', otherwise do nothing!
export enum ShiftAction {
	AddOverride = 'add-override',
	Cancel = 'cancel',
}

export enum PageModalType {
	EditMode = 'edit-mode',
	TakeOnCall = 'take-on-call',
	AddOverride = 'add-override',
	RevertOverride = 'revert-override',
	DeleteSchedule = 'delete-schedule',
	CreateSchedule = 'create-schedule',
	DeleteRotation = 'delete-rotation',
	DiscardChanges = 'discard-changes',
}

export enum Scope {
	Edit = 'edit',
}

export enum TimingType {
	Everday = 'everyday',
	Customday = 'customday',
}

export type DayTimeRange = {
	startMinute: number;
	startHour: number;
	startDay: number;
	endMinute: number;
	endHour: number;
	endDay: number;
};

export type TimeRange = {
	startHour: number;
	startMinute: number;
	endHour: number;
	endMinute: number;
};

export enum ShiftFrequency {
	Daily = 'daily',
	Weekly = 'weekly',
	Custom = 'custom',
}

export enum RotationType {
	DAILY = 'daily',
	WEEKLY = 'weekly',
	HOURLY = 'hourly',
	INVALID = 'invalid',
}

export type RotationDetail = {
	id?: string;
	name: string;
	startTimeRaw: string;
	endTimeRaw?: string;
	responders: RequestedResponder[];
	rotationPeriod: number;
	rotationType: RotationType;
	restrictions?: DayTimeRange[];
	timingType?: TimingType | null;
	timeTemplateId?: string | null;
};

export type Rotation = PeriodTable<Period>;

export type RotationBase = Pick<Rotation, 'id' | 'name'>;

export type OptionField<T> = {
	label: string;
	value: T;
	name: T;
};

export type SelectOption = {
	label: string;
	value: string;
};

type IsRequired<T, R, K extends keyof T = keyof T> = R extends true
	? {
			[P in K]-?: T[P];
		}
	: T;

export type ActiveOverride<
	RequiredResponder extends boolean = false,
	RequiredAlias extends boolean = false,
> = {
	alias?: string;
	rotations: { id: string; name?: string }[];
	from?: RequestedResponder<true, true>;
} & PeriodRange &
	IsRequired<{ responder?: RequestedResponder }, RequiredResponder> &
	IsRequired<{ alias?: string }, RequiredAlias>;

export type ActionCallback = {
	onSuccess?: () => void;
	onError?: () => void;
};
